var React = require('react');

function StopSign (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M24 3C12.402 3 3 12.402 3 24s9.402 21 21 21 21-9.402 21-21S35.598 3 24 3zM0 24C0 10.746 10.746 0 24 0s24 10.746 24 24-10.746 24-24 24S0 37.254 0 24z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M40.97 7.03a1.5 1.5 0 010 2.12L9.15 40.97a1.5 1.5 0 11-2.12-2.12L38.85 7.03a1.5 1.5 0 012.12 0z","key":1})]);
}

StopSign.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = StopSign;

StopSign.default = StopSign;
